import React from "react";
import { Link } from "react-router-dom";

import { Country } from "country-state-city";
//import { Navigate } from 'react-router-dom';
import Login from "./Login";
import DsDatePicker from "./templates/DsDatePicker";
import PhoneEmailSignIn from "./templates/PhoneEmailSignIn";
const url = window.location.protocol + "//" + window.location.host;

let respMsg = "";
let data = {};

class Booking extends React.Component {
  constructor(props) {
    super(props);
    window.scroll({
      top: window.scrollY > 0 ? 0 : 1,
      left: 0,
      behavior: "smooth",
    });
    this.countries = [];
    this.countries.push({
      name: "India",
      isoCode: "IN",
      flag: "🇮🇳",
      phonecode: "91",
      currency: "INR",
      latitude: "20.00000000",
      longitude: "77.00000000",
      timezones: [
        {
          zoneName: "Asia/Kolkata",
          gmtOffset: 19800,
          gmtOffsetName: "UTC+05:30",
          abbreviation: "IST",
          tzName: "Indian Standard Time",
        },
      ],
    });
    Country.getAllCountries().forEach((x) => {
      this.countries.push(x);
    });

    console.log(this.countries);
    let people = window.localStorage.getItem("people");
    let slot = window.localStorage.getItem("formdata");
    try {
      slot = JSON.parse(slot);
      slot = JSON.parse(slot.slot);
    } catch (error) {}
    console.log(slot);
    people = people !== null ? JSON.parse(people) : [];

    // Load form data from localStorage
    const savedFormData = this.loadFormData();

    this.state = {
      loading: true,
      viewform: false,
      selectedSlot: slot,
      mobile: savedFormData.mobile || "",
      country: savedFormData.country || "91",
      process: false,
      respMsg: "",
      err: "",
      res: "",
      phoneVerified: savedFormData.phoneVerified || false,
      phoneVerificationUrl: savedFormData.phoneVerificationUrl || null,
      people: people,
      user: null,
      bookingSuccess: false,
      bookingId: null,
    };

    data = this.getDatesSlots();
    //this.handleLoad = this.handleLoad.bind(this);
  }

  // Load form data from localStorage
  loadFormData = () => {
    try {
      const savedData = window.localStorage.getItem("bookingFormData");
      if (savedData) {
        return JSON.parse(savedData);
      }
    } catch (error) {
      console.error("Error loading form data from localStorage:", error);
    }
    return {};
  };

  // Save form data to localStorage
  saveFormData = () => {
    try {
      const formData = {
        mobile: this.state.mobile,
        country: this.state.country,
        phoneVerified: this.state.phoneVerified,
        phoneVerificationUrl: this.state.phoneVerificationUrl,
        savedAt: new Date().toISOString(),
      };
      window.localStorage.setItem("bookingFormData", JSON.stringify(formData));
    } catch (error) {
      console.error("Error saving form data to localStorage:", error);
    }
  };

  componentDidMount() {
    //window.addEventListener('load', this.handleLoad);

    // Save form data whenever state changes
    this.saveFormData();
  }

  componentDidUpdate(prevProps, prevState) {
    // Save form data when relevant state changes
    if (
      prevState.mobile !== this.state.mobile ||
      prevState.country !== this.state.country ||
      prevState.phoneVerified !== this.state.phoneVerified ||
      prevState.phoneVerificationUrl !== this.state.phoneVerificationUrl
    ) {
      this.saveFormData();
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { name } = e.target.elements;
    this.props.global
      .fireUpdateProfile(name.value)
      .then((result) => {
        this.props.global.user.displayName = name.value;
        this.setState({ loading: false });
      })
      .catch((err) => console.log(err));
  };

  handlemobile = async (e) => {
    e.preventDefault();
    let mobile = document.getElementById("cmobile")?.value || "";
    let country = document.getElementById("country")?.value || "91";
    this.setState({
      country: country,
      mobile: mobile,
      phoneVerified: false,
      phoneVerificationUrl: null,
    });
    return mobile;
  };

  getDatesSlots = (dt = false) => {
    data["sdate"] = window.localStorage.getItem("selectedate");
    this.props.global.selectedDate =
      data.sdate !== undefined && isNaN(data.sdate)
        ? new Date(data.sdate)
        : new Date();

    let people = window.localStorage.getItem("bookingData");
    people = people !== null && people !== undefined ? JSON.parse(people) : [];
    data.people = people;
    let json = window.localStorage.getItem("formdata");
    try {
      json = JSON.parse(json);
      this.setState({
        selectedSlot: JSON.parse(json.slot),
      });
    } catch (ex) {
      json = {
        date: "",
        slot: "",
      };
    }
    data.slot = json !== null ? json.slot : "";
    return data;
  };

  showExt = (e) => {
    if (
      e.target.parentElement.parentElement.querySelector(
        ".extended-content"
      ) !== null
    ) {
      e.target.parentElement.parentElement
        .querySelector(".extended-content")
        .classList.add("d-block");
    }
  };

  selectSlot = (e) => {
    let data = {
      date: this.props.global.datePicker(
        window.localStorage.getItem("selectedate"),
        0,
        "YM1D"
      ),
      slot: e.target.value,
    };
    console.log(data);
    this.setState({
      selectedSlot: JSON.parse(data.slot),
    });
    window.localStorage.setItem("formdata", JSON.stringify(data));
    if (e.target.value !== "") {
      window.location.href = "#hashPerson";
      document.getElementById("addPerson").classList.add("d-block");
    }
  };

  signoff = (e) => {
    let confirm = window.confirm("Are you sure you want to signout?");
    if (confirm) {
      this.props.global
        .fireSignOut()
        .then((res) => {
          this.props.global.user = null;
          this.setState({
            isLogin: this.props.global.user,
          });

          window.scroll({
            top: window.scrollY > 0 ? 0 : 1,
            left: 0,
            behavior: "smooth",
          });
          window.location.reload();
        })
        .catch((err) => {});
    }
  };

  addPersons = async (e) => {
    e.preventDefault();

    const { pname, gender, nationality, dno, dob } = e.target.elements;
    let people = this.state.people;
    //bookingData = bookingData === null || bookingData.length < 1 ? '[]' : bookingData
    let alert = 0;
    try {
      let json = window.localStorage.getItem("formdata");

      //bkdata = JSON.parse(bkdata);

      json = JSON.parse(json);
      this.setState({
        selectedSlot: json,
      });
      let slot = json["slot"] !== undefined ? JSON.parse(json["slot"]) : false;

      // Validate age - must be above 8 years
      const dobDate = new Date(dob.value);
      const today = new Date();
      const age = Math.floor(
        (today - dobDate) / (365.25 * 24 * 60 * 60 * 1000)
      );

      if (age <= 8) {
        window.alert(
          "Age must be above 8 years. Please enter a valid date of birth."
        );
        alert = -2;
        return alert;
      }

      let peopleData = {
        pname: pname.value,
        gender: gender.value,
        dob: dob.value,
        nationality: nationality.value,
        dno: dno.value,
      };
      /* let postData = {
                 slot: json['slot'],
                 date: json.date, people: {
                     pname: pname.value,
                     gender: gender.value,
                     dob: dob.value,
                     nationality: nationality.value,
                     dno: dno.value
                 }
             };*/

      people = people.filter((x) => {
        return x.dno !== dno.value;
      });
      alert = 1;

      if (slot && people.length < slot.available) {
        people.push(peopleData);

        window.localStorage.setItem("people", JSON.stringify(people));
        this.setState({
          people: people,
        });
        alert = 3;
      } else {
        window.alert("Max Number of limit per booking is exceeded!");
        alert = -1;
      }
    } catch (ex) {
      alert = 0;
    }

    return alert;
  };

  addPerson = async (e) => {
    await this.addPersons(e);
    data = this.getDatesSlots();

    document.querySelector("#addPerson form").reset();
    document.getElementById("addPerson").classList.remove("d-block");
    this.setState({});
  };

  removePerson = (e) => {
    e.preventDefault();

    var id = e.target.getAttribute("data-id");
    let people = this.state.people;
    //bookingData = typeof (bookingData) === 'string' ? JSON.parse(bookingData) : [];

    if (Array.isArray(people) && people.length > 0) {
      let confirm = window.confirm(
        "Are you sure to remove " + people[id].pname + "?"
      );
      if (confirm) {
        people.splice(id, 1);
        window.localStorage.setItem("people", JSON.stringify(people));
        this.setState({
          people: people,
        });
        data = this.getDatesSlots();
        window.location.href = "/#rb_people";
      }
    }
  };

  filtermobile = (str) => {
    str = str.split("-");
    if (str.length > 1) {
      str = str.slice(1).join("");
    } else {
      str = str[0];
    }
    str = str.replace(/\D/g, "");
    return str;
  };

  handlePhoneVerification = async (user_json_url) => {
    // Set loading state
    this.setState({
      phoneVerified: false,
      phoneVerificationUrl: user_json_url,
      respMsg:
        "<div className='alert alert-info'><strong>Phone verification successful!</strong><br />Retrieving phone number from backend...</div>",
    });

    // Fetch phone number from backend using user_json_url
    try {
      const response = await fetch(user_json_url);
      if (response.ok) {
        const jsonData = await response.json();

        // Validate response structure
        if (!jsonData || !jsonData.user_phone_number) {
          throw new Error("Invalid response from phone verification service");
        }

        const user_country_code = jsonData.user_country_code || "";
        const user_phone_number = jsonData.user_phone_number || "";

        // Remove '+' from country code if present (e.g., "+91" -> "91")
        const countryCode = user_country_code.replace(/^\+/, "");

        // Format: country_code-phone_number
        const fullMobile = countryCode + "-" + user_phone_number;

        // Store phone verification response in localStorage
        const phoneVerificationData = {
          user_country_code: user_country_code,
          user_phone_number: user_phone_number,
          user_first_name: jsonData.user_first_name || "",
          user_last_name: jsonData.user_last_name || "",
          country_code: countryCode,
          full_mobile: fullMobile,
          verified_at: new Date().toISOString(),
          user_json_url: user_json_url,
        };
        window.localStorage.setItem(
          "phoneVerification",
          JSON.stringify(phoneVerificationData)
        );

        // Update state with verified phone info and set phoneVerified to true
        this.setState({
          phoneVerified: true,
          mobile: user_phone_number,
          country: countryCode,
          respMsg:
            "<div className='alert alert-success'><strong>Phone verification successful!</strong><br />Phone: +" +
            countryCode +
            "-" +
            user_phone_number +
            "<br />Please click 'Confirm Booking' button to complete your booking.</div>",
        });

        // Do NOT automatically process booking - wait for user to click "Confirm Booking" button
      } else {
        throw new Error("Failed to fetch phone number from backend");
      }
    } catch (error) {
      console.error("Error fetching phone number:", error);
      this.setState({
        phoneVerified: false,
        respMsg:
          "<div className='alert alert-danger'><strong>Error:</strong> Failed to retrieve phone number. Please try again.</div>",
      });
    }
  };

  validateBooking = async (mobile) => {
    if (mobile) {
      let fdata = window.localStorage.getItem("formdata");
      respMsg =
        "<div className='alert alert-info'><strong>Processing booking...</strong><br />Please wait...</div>";
      this.setState({
        respMsg: respMsg,
        process: true,
      });

      try {
        fdata = fdata !== null ? JSON.parse(fdata) : {};
      } catch (error) {
        console.error("Error parsing formdata:", error);
        fdata = {};
      }

      // Validate required data
      if (!fdata.slot || !fdata.date) {
        respMsg =
          "<div className='alert alert-danger'><strong>Error:</strong> Please select a date and slot before booking.</div>";
        this.setState({
          respMsg: respMsg,
          process: false,
        });
        return;
      }

      let bookingData = {
        slot: fdata.slot,
        date: fdata.date,
        people: this.state.people || [],
        mobile: mobile,
        phoneVerificationUrl: this.state.phoneVerificationUrl,
      };

      try {
        let resp = await this.props.global.processBooking(bookingData);

        if (resp !== undefined && resp.res === "success") {
          respMsg = `<div class="alert alert-success"><strong>${resp.msg}</strong><br /><a href="${window.location.protocol}//${window.location.host}/booking/${resp.id}">View Ticket</a></div>`;
          window.localStorage.removeItem("formdata");
          window.localStorage.removeItem("people");
          window.localStorage.removeItem("selectedate");
          window.localStorage.removeItem("bookingFormData");
          window.localStorage.removeItem("phoneVerification");

          // Hide phone verification section and show success message
          this.setState({
            respMsg: respMsg,
            process: false,
            bookingSuccess: true,
            bookingId: resp.id,
            phoneVerified: false, // Hide phone verification section
          });
        } else {
          respMsg = `<div class='alert alert-danger'>${
            resp?.msg || "Booking failed. Please try again."
          }</div>`;
          this.setState({
            respMsg: respMsg,
            process: false,
          });
        }
      } catch (error) {
        console.error("Error processing booking:", error);
        respMsg = `<div class='alert alert-danger'><strong>Error:</strong> ${
          error.message || "Booking failed. Please try again."
        }</div>`;
        this.setState({
          respMsg: respMsg,
          process: false,
        });
      }
    } else {
      respMsg =
        "<div class='alert alert-danger'>Phone verification is required. Please verify your phone number.</div>";
      this.setState({
        respMsg: respMsg,
      });
    }
  };

  validateProcess = (e) => {
    e.preventDefault();
    respMsg =
      "<div className='alert alert-info'>Please verify your phone number using the button below.</div>";
    this.setState({
      respMsg: respMsg,
    });
  };

  verifyModal = async (e) => {
    let slot;
    try {
      slot = JSON.parse(data.slot);
    } catch (ex) {
      slot = data.slot;
    }
    if (slot === "") {
      alert("Please select a slot");
      const slotsElement = document.getElementById("slots");
      if (slotsElement) {
        slotsElement.focus();
      }
    } else if (
      Array.isArray(this.state.people) &&
      this.state.people.length < 1
    ) {
      alert("Please add person for the booking");

      const addPersonElement = document.getElementById("addPerson");
      if (addPersonElement) {
        addPersonElement.classList.add("d-block");
      }
      window.location.href = "/#hashPerson";
    } else if (
      Array.isArray(this.state.people) &&
      this.state.people.length > slot.available
    ) {
      alert("Maximum allowed people exceeded for the slot " + slot.slot);
      const slotsElement = document.getElementById("slots");
      if (slotsElement) {
        slotsElement.focus();
      }
    } else if (!this.state.phoneVerified) {
      alert(
        "Please verify your phone number using the phone.email button above to complete the booking!"
      );
    } else if (
      Array.isArray(this.state.people) &&
      this.state.people.length + slot.booked > slot.available
    ) {
      alert(
        "Maximum allowed people exceeded for the slot " +
          slot.slot +
          ". Please remove all extra people or change the booking slot!"
      );
      const slotsElement = document.getElementById("slots");
      if (slotsElement) {
        slotsElement.focus();
      }
    } else if (
      Array.isArray(this.state.people) &&
      this.state.people.length > 0 &&
      this.state.people.length <= slot.available
    ) {
      // If phone is already verified, proceed with booking
      if (this.state.phoneVerified && this.state.mobile) {
        await this.validateBooking(
          this.state.country + "-" + this.state.mobile
        );
      } else {
        // Show verification message
        alert(
          "Please verify your phone number using the phone.email button above to complete the booking."
        );
      }
    }
  };

  getprops = async () => {
    this.auth = this.props.global.fAuth;
    setTimeout(() => {
      this.props.global.user = this.auth.currentUser;

      if (this.auth !== undefined) {
        this.setState({ loading: false });
      }
    }, 1000);
  };

  setPassword = async (e) => {
    e.preventDefault();
    const email = this.props.global.user.email;

    let confirm = window.prompt("Please enter your email to confirm");
    if (confirm === email) {
      this.props.global
        .resetPassword(email)
        .then((res) => {
          this.setState({
            err: "",
            res: "A link has been sent to your email address to set a password. Sometimes it may be in spam.",
          });
        })
        .catch((err) => {
          this.setState({
            err: this.props.global.fireError(err.message),
            res: "",
          });
        });
    }
  };
  //this.props.global.Verify();

  calcPercentage = (total, available) => {
    total = parseInt(total);
    available = parseInt(available);
    return available > 0 ? (total / available) * 100 : available;
  };

  updateSlot = () => {
    try {
      let slot = window.localStorage.getItem("formdata");
      slot = JSON.parse(slot);
      slot = JSON.parse(slot.slot);
      this.setState({
        selectedSlot: slot,
      });
      ///this.props.state.selectedSlot = slot;
    } catch (error) {}
  };

  generateString(length) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  render() {
    if (this.state.loading === true) {
      this.getprops();
      return (
        <div className="preloader">
          <div className="loader" id="loader-1"></div>
        </div>
      );
    } else {
      if (this.auth.currentUser !== null) {
        let iframe = document.getElementById("webWidget");
        if (iframe !== null) {
          let iDoc = iframe.contentDocument || iframe.contentWindow.document;
          if (iDoc) {
            iDoc
              .querySelector('input[name="email"]')
              .setAttribute("placeholder", "?: " + this.auth.currentUser.email);
            iDoc
              .querySelector('input[name="name"]')
              .setAttribute(
                "placeholder",
                "?: " + this.auth.currentUser.displayName
              );
          }
        }
      }
      return (
        <>
          <section
            id="booking"
            className={"page-header proj-det bg-img valign"}
            style={{
              backgroundImage: `url('${url}/assets/img/background/charanam.jpg')`,
            }}
          >
            <div className="container">
              <div className="row">
                <div
                  className={
                    this.state.viewform
                      ? "timeline containerx view"
                      : "timeline containerx view"
                  }
                  onClick={() => {
                    this.setState({
                      viewform: true,
                    });
                  }}
                >
                  <div className="rightbox" id="topbox">
                    <div className="rb-container">
                      <div className="logo d-none">
                        <a href={url}>
                          <img
                            src={url + "/assets/img/logobig.png"}
                            alt="Sri Sathya Sai Divya Smriti"
                          />
                        </a>
                      </div>
                      <ul className="rb">
                        {this.props.global.user === null ? (
                          <li
                            id="rb_login"
                            className="rb-item"
                            ng-repeat="itembx"
                          >
                            <div
                              id="rb_login_e"
                              className="rb-content"
                              onClick={this.showExt}
                            >
                              <div className="timestamp">
                                Register / Login{" "}
                                <i className="fa fa-angle-double-right"></i>
                              </div>
                              <div className="item-title">
                                Login to do the booking.
                              </div>
                            </div>
                            <div className="extended-content">
                              <div className="row">
                                <div className="col-md-12 text-center">
                                  <Login
                                    authcheck={this.props.authcheck}
                                    global={this.props.global}
                                  />
                                </div>
                              </div>
                            </div>
                          </li>
                        ) : (
                          <li
                            id="rb_login"
                            className="rb-item"
                            ng-repeat="itembx"
                          >
                            <div
                              id="rb_login_e"
                              className="rb-content"
                              onClick={this.showExt}
                            >
                              <h4>
                                Sairam{" "}
                                {this.props.global.user !== null &&
                                this.props.global.user.displayName !== null
                                  ? this.props.global.user.displayName
                                  : "User"}
                                !
                              </h4>
                              <div className="timestamp">
                                You are logged-in{" "}
                                <i className="fa fa-angle-double-right"></i>
                              </div>
                              <div className="item-title">
                                Set Display Name / View Booking History
                              </div>
                            </div>
                            <div className="extended-content">
                              <div className="row">
                                <div className="col-md-12 text-center">
                                  {this.props.global.user !== null ? (
                                    <>
                                      <form
                                        style={{ position: "relative" }}
                                        onSubmit={this.handleSubmit}
                                      >
                                        <div className="form-group mb-3">
                                          <input
                                            type="text"
                                            style={{ fontSize: "12px" }}
                                            name="name"
                                            className="form-control"
                                            placeholder="Set / Change Display Name"
                                            defaultValue={
                                              this.props.global.user.displayName
                                            }
                                          />
                                          <button
                                            style={{
                                              position: "absolute",
                                              top: "1px",
                                              right: "0px",
                                            }}
                                            type="submit"
                                            className="btn btn-theme-1"
                                          >
                                            <i
                                              className="fa fa-save"
                                              title="Save"
                                            ></i>
                                          </button>
                                        </div>

                                        <div className="mt-5"></div>
                                        <div className="form-group mb-3">
                                          <pre>
                                            {this.props.global.user.email}
                                          </pre>
                                          <button
                                            onClick={this.setPassword}
                                            className="btn btn-sm btn-primary"
                                          >
                                            Set Password
                                          </button>
                                        </div>
                                        <span className="text-danger">
                                          {this.state.err}
                                        </span>
                                        <span className="text-success">
                                          {this.state.res}
                                        </span>
                                      </form>
                                      <ul className="list-group">
                                        <li className="list-group-item">
                                          <Link to={"/bookings"}>
                                            View Booking History
                                          </Link>
                                        </li>
                                      </ul>
                                      <br />
                                      <button
                                        className="btn btn-dark"
                                        onClick={this.signoff}
                                      >
                                        Sign out
                                      </button>
                                    </>
                                  ) : (
                                    <Login
                                      authcheck={this.props.authcheck}
                                      global={this.props.global}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </li>
                        )}

                        <li id="rb_date" className="rb-item" ng-repeat="itembx">
                          <div className="rb-content">
                            <>
                              <div className="timestamp">
                                Choose a Date{" "}
                                <i className="fa fa-angle-double-down"></i>
                              </div>
                              <div className="item-title">
                                <div className="form-group">
                                  <DsDatePicker
                                    selectedSlot={this.updateSlot}
                                    global={this.props.global}
                                  />
                                </div>
                              </div>
                            </>
                          </div>
                          <div className="extended-content">
                            <div className="row">
                              <div className="col-md-12 text-center">
                                <Login
                                  authcheck={this.props.authcheck}
                                  global={this.props.global}
                                />
                              </div>
                            </div>
                          </div>
                        </li>

                        <li id="rb_slot" className="rb-item" ng-repeat="itembx">
                          <div className="rb-content">
                            <div className="timestamp">
                              Choose a Slot{" "}
                              <i className="fa fa-angle-double-down"></i>
                            </div>
                            <div className="item-title">
                              <div className="form-group">
                                {Array.isArray(this.props.global.slots) &&
                                this.props.global.slots.length > 0 ? (
                                  <select
                                    className="form-control"
                                    name="slots"
                                    id="slots"
                                    defaultValue={data.slot}
                                    onChange={this.selectSlot}
                                    required
                                  >
                                    <option value={""}>Select Time Slot</option>
                                    {this.props.global.slots.map((x) => {
                                      return (
                                        <option
                                          key={x.Slot}
                                          value={JSON.stringify({
                                            slot: x.Slot,
                                            available: x.Available,
                                            booked: x.Booked,
                                          })}
                                        >
                                          {x.Slot}
                                        </option>
                                      );
                                    })}
                                  </select>
                                ) : (
                                  <>
                                    {data.sdate === null ? (
                                      <></>
                                    ) : (
                                      <div className="text-danger">
                                        No Slot Available on{" "}
                                        {this.props.global.formatDate(
                                          data.sdate,
                                          "YMMMD"
                                        )}
                                        <br />
                                        <a href="#rb_date">
                                          <strong>Change the date</strong>
                                        </a>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                            <div id="hashPerson"></div>
                          </div>
                        </li>

                        <li
                          id="rb_people"
                          className="rb-item"
                          ng-repeat="itembx"
                        >
                          <div className="rb-content" onClick={this.showExt}>
                            <div className="timestamp">
                              {Array.isArray(data.people) &&
                              data.people.length > 0 ? (
                                <>
                                  Visitor's Details{" "}
                                  <i className="fa fa-angle-double-down"></i>
                                  <hr />
                                </>
                              ) : (
                                <>
                                  Add Visitors{" "}
                                  <i className="fa fa-angle-double-right"></i>
                                </>
                              )}
                            </div>
                            <div
                              id="addPerson"
                              style={{ maxWidth: "450px" }}
                              className="extended-content"
                            >
                              <h4>Add Details</h4>
                              <form onSubmit={this.addPerson}>
                                <div className="row">
                                  {this.state.people.length < 1 ? (
                                    <div className="col-md-12">
                                      <label>Document#</label>
                                      <input
                                        onBlur={(e) => {
                                          let found = this.state.people.filter(
                                            (x) => {
                                              return x.dno === e.target.value;
                                            }
                                          );
                                          if (
                                            found !== undefined &&
                                            found.length > 0
                                          ) {
                                            document.getElementById(
                                              "pname"
                                            ).value = found[0].pname;
                                            document.getElementById(
                                              "dob"
                                            ).value = found[0].dob;
                                            document.getElementById(
                                              "gender"
                                            ).value = found[0].gender;
                                            document.getElementById(
                                              "nationality"
                                            ).value = found[0].nationality;
                                          } else {
                                            document.getElementById(
                                              "pname"
                                            ).value = "";
                                            document.getElementById(
                                              "dob"
                                            ).value = "";
                                            document.getElementById(
                                              "gender"
                                            ).value = "";
                                            document.getElementById(
                                              "nationality"
                                            ).value = "";
                                          }
                                        }}
                                        pattern=".{5,14}"
                                        title="Must be a valid Document"
                                        type={"text"}
                                        className="form-control"
                                        id="dno"
                                        required
                                        name="dno[]"
                                        placeholder="Valid document #"
                                      />
                                      <small>
                                        Valid document type: Aadhaar#,
                                        passport#, driving licence, Sri Sathya
                                        Sai staff / student ID or any other that
                                        represent your identity. Accompanying
                                        persons' document id(s) is/are not
                                        mandatory.
                                      </small>
                                    </div>
                                  ) : (
                                    <>
                                      <input
                                        pattern=".{5,14}"
                                        title="Must be a valid Document"
                                        type={"hidden"}
                                        className="form-control"
                                        id="dno"
                                        required
                                        name="dno[]"
                                        defaultValue={this.generateString(10)}
                                        placeholder="Valid document #"
                                      />
                                    </>
                                  )}

                                  <hr />
                                  <div className="col-md-12">
                                    <label>Name</label>
                                    <input
                                      type={"text"}
                                      className="form-control"
                                      required
                                      id="pname"
                                      name="pname[]"
                                      placeholder="Person's Name"
                                    />
                                  </div>
                                  <div className="col-md-12">
                                    <label>Date of Birth</label>
                                    <input
                                      type={"date"}
                                      className="form-control"
                                      onClick={this.props.global.showPicker}
                                      min={this.props.global.datePicker(
                                        "",
                                        -63540
                                      )}
                                      max={this.props.global.datePicker(
                                        "",
                                        -2930
                                      )}
                                      required
                                      id="dob"
                                      name="dob[]"
                                      placeholder="Date of Birth"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <label>Gender</label>
                                    <select
                                      name="gender[]"
                                      className="form-control"
                                      id="gender"
                                      required
                                    >
                                      <option value={""}>Select Gender</option>
                                      <option value={"M"}>Male</option>
                                      <option value={"F"}>Female</option>
                                      <option value={"O"}>Other</option>
                                    </select>
                                    <br />
                                  </div>
                                  <div className="col-md-6">
                                    <label>Nationality</label>
                                    <select
                                      name="nationality[]"
                                      className="form-control"
                                      id="nationality"
                                      required
                                    >
                                      <option value={"IN"}>Indian</option>
                                      <option value={"OTHER"}>OTHER</option>
                                    </select>
                                    <br />
                                  </div>

                                  <div className="row">
                                    <div
                                      className="col-md-12 text-right"
                                      style={{ textAlign: "right" }}
                                    >
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                      >
                                        SAVE
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                            <div className="item-title">
                              {Array.isArray(this.state.people) &&
                              this.state.people.length > 0 ? (
                                <>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <progress
                                        className="w-100"
                                        max={
                                          typeof this.state.selectedSlot ===
                                          "object"
                                            ? this.state.selectedSlot
                                                .available -
                                              this.state.selectedSlot.booked
                                            : ""
                                        }
                                        value={this.state.people.length}
                                      ></progress>
                                    </div>
                                    <hr />
                                  </div>
                                  <div className="">
                                    <div className="">
                                      {this.state.people.map((x, i) => {
                                        return (
                                          <>
                                            <div className="row" key={i}>
                                              <div className="col-2">
                                                <span className="indexn">
                                                  {i + 1}
                                                </span>
                                              </div>
                                              <div className="col-8">
                                                <div className="row">
                                                  <div className="col-md-10">
                                                    <div
                                                      className={
                                                        {
                                                          "": "",
                                                          M: "is-male",
                                                          F: "is-female",
                                                          O: "is-other",
                                                        }[x.gender]
                                                      }
                                                    >
                                                      <strong>
                                                        Name (Gender):
                                                      </strong>
                                                      <br />
                                                      {x.pname} (
                                                      {
                                                        {
                                                          "": "",
                                                          M: "M",
                                                          F: "F",
                                                          O: "O",
                                                        }[x.gender]
                                                      }
                                                      )
                                                    </div>
                                                  </div>
                                                  <div className="col-md-10">
                                                    <div
                                                      className={
                                                        this.props.global.getAge(
                                                          x.dob
                                                        ) < 13
                                                          ? "is-child"
                                                          : "is-adult"
                                                      }
                                                    >
                                                      <strong>
                                                        Birthdate (Age):
                                                        <br />
                                                      </strong>{" "}
                                                      {this.props.global.formatDate(
                                                        x.dob,
                                                        "D-M-Y"
                                                      )}{" "}
                                                      (
                                                      {this.props.global.getAge(
                                                        x.dob
                                                      )}{" "}
                                                      Years)
                                                    </div>
                                                  </div>
                                                  <div className="col-md-12 col-12">
                                                    <div
                                                      className={
                                                        x.nationality === "IN"
                                                          ? "text-india"
                                                          : "text-other"
                                                      }
                                                    >
                                                      <strong>Document#</strong>{" "}
                                                      {x.dno} ({x.nationality})
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-2">
                                                <button
                                                  className="btn btn-danger btn-sm deletebtn"
                                                  onClick={this.removePerson}
                                                  data-id={i}
                                                >
                                                  X
                                                </button>
                                              </div>
                                            </div>
                                            <hr />
                                          </>
                                        );
                                      })}
                                    </div>
                                  </div>
                                  <div>
                                    <progress
                                      className="w-100"
                                      max={
                                        typeof this.state.selectedSlot ===
                                        "object"
                                          ? this.state.selectedSlot.available -
                                            this.state.selectedSlot.booked
                                          : ""
                                      }
                                      value={this.state.people.length}
                                    ></progress>
                                    <div className="peoplebar">
                                      <div className="progress">
                                        <div
                                          className="progress-bar bg-light"
                                          role="progressbar"
                                          style={{
                                            width: `${this.calcPercentage(
                                              this.state.selectedSlot.booked,
                                              this.state.selectedSlot.available
                                            )}%`,
                                          }}
                                          title="Booked"
                                          aria-valuenow={
                                            this.state.selectedSlot.booked
                                          }
                                          aria-valuemin="0"
                                          aria-valuemax={
                                            this.state.selectedSlot.available
                                          }
                                        >
                                          {this.state.selectedSlot.booked}
                                        </div>
                                        <div
                                          className="progress-bar bg-primary"
                                          title="Booking"
                                          role="progressbar"
                                          style={{
                                            width: `${this.calcPercentage(
                                              this.state.people.length,
                                              this.state.selectedSlot.available
                                            )}%`,
                                          }}
                                          aria-valuenow={
                                            this.state.people.length
                                          }
                                          aria-valuemin="0"
                                          aria-valuemax={
                                            this.state.selectedSlot.available
                                          }
                                        >
                                          {this.state.people.length}
                                        </div>
                                        <div
                                          className="progress-bar bg-light"
                                          title="Available"
                                          role="progressbar"
                                          style={{
                                            width: `${
                                              100 -
                                              this.calcPercentage(
                                                this.state.people.length +
                                                  this.state.selectedSlot
                                                    .booked,
                                                this.state.selectedSlot
                                                  .available
                                              )
                                            }%`,
                                          }}
                                          aria-valuenow={
                                            this.state.people.length +
                                            this.state.selectedSlot.booked
                                          }
                                          aria-valuemin="0"
                                          aria-valuemax={
                                            this.state.selectedSlot.available
                                          }
                                        >
                                          {this.state.selectedSlot.available -
                                            (this.state.selectedSlot.booked +
                                              this.state.people.length)}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="p-1"></div>
                                  </div>

                                  {this.state.selectedSlot.booked +
                                    this.state.people.length <
                                  this.state.selectedSlot.available ? (
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => {
                                        window.location.href = "/#hashPerson";
                                      }}
                                    >
                                      Add More People
                                    </button>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  Click / Touch to add accompanying people data
                                </>
                              )}
                            </div>
                          </div>
                        </li>

                        {this.props.global.user !== null &&
                        typeof data.slot === "string" &&
                        Array.isArray(this.state.people) &&
                        this.state.people.length > 0 ? (
                          <>
                            <li className="rb-item" ng-repeat="itembx">
                              <div className="rb-content">
                                {this.state.bookingSuccess ? (
                                  <div className="form-group">
                                    <div
                                      id="respMsg"
                                      dangerouslySetInnerHTML={{
                                        __html: this.state.respMsg,
                                      }}
                                    ></div>
                                  </div>
                                ) : (
                                  <>
                                    <div className="form-group">
                                      {!this.state.phoneVerified ? (
                                        <>
                                          <h5>Phone Verification Required</h5>
                                          <p>
                                            Please verify your phone number to
                                            complete the booking
                                          </p>
                                          <div className="p-3 text-center">
                                            <PhoneEmailSignIn
                                              key={`phone-verify-${
                                                this.state.phoneVerified
                                              }-${
                                                this.state
                                                  .phoneVerificationUrl || "new"
                                              }`}
                                              clientId={
                                                this.props.global?.env
                                                  ?.phoneEmail?.clientId
                                              }
                                              onVerificationSuccess={
                                                this.handlePhoneVerification
                                              }
                                            />
                                          </div>
                                          <br />
                                          <small>
                                            Phone verification is required to
                                            complete your booking. Click the
                                            button above to verify your phone
                                            number.
                                          </small>
                                        </>
                                      ) : (
                                        <div className="alert alert-success mt-2">
                                          <strong>✓ Phone Verified:</strong>{" "}
                                          {this.state.country &&
                                          this.state.mobile
                                            ? `+${this.state.country}-${this.state.mobile}`
                                            : "Phone number verified"}
                                          <br />
                                          <button
                                            className="btn btn-sm btn-link mt-2 p-0"
                                            onClick={() => {
                                              // Clear phone verification data
                                              window.localStorage.removeItem(
                                                "phoneVerification"
                                              );
                                              window.localStorage.removeItem(
                                                "bookingFormData"
                                              );
                                              this.setState({
                                                phoneVerified: false,
                                                mobile: "",
                                                country: "",
                                                phoneVerificationUrl: null,
                                              });
                                            }}
                                          >
                                            Change Number
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      className="timestamp"
                                      onClick={this.verifyModal}
                                    >
                                      {this.state.phoneVerified
                                        ? "Confirm Booking"
                                        : "Verify Phone & Confirm Booking"}{" "}
                                      <i className="fa fa-flag"></i>
                                    </div>
                                    <div
                                      className="item-title"
                                      onClick={this.verifyModal}
                                    >
                                      {this.state.phoneVerified
                                        ? "Click / Touch to confirm your booking."
                                        : "Please verify your phone number above, then click to confirm booking."}
                                    </div>
                                    <hr />
                                    {this.state.phoneVerified && (
                                      <div className="text-right">
                                        <button
                                          className="btn btn-primary"
                                          onClick={this.verifyModal}
                                        >
                                          Confirm Booking
                                        </button>
                                      </div>
                                    )}
                                  </>
                                )}
                                <div
                                  id="verifyBook"
                                  className="extended-content"
                                >
                                  <div className="veriFy">
                                    <form
                                      autoComplete="off"
                                      onSubmit={this.validateProcess}
                                    >
                                      <div className="verification text-center">
                                        {!this.state.phoneVerified ? (
                                          <>
                                            <h5>
                                              Please verify your phone number to
                                              complete the booking
                                            </h5>
                                            <p>
                                              Click the button below to verify
                                              your phone number using OTP
                                            </p>

                                            <div className="p-3">
                                              <PhoneEmailSignIn
                                                key={`phone-verify-modal-${
                                                  this.state.phoneVerified
                                                }-${
                                                  this.state
                                                    .phoneVerificationUrl ||
                                                  "new"
                                                }`}
                                                clientId={
                                                  this.props.global?.env
                                                    ?.phoneEmail?.clientId
                                                }
                                                onVerificationSuccess={
                                                  this.handlePhoneVerification
                                                }
                                              />
                                            </div>
                                          </>
                                        ) : (
                                          <div className="alert alert-success">
                                            <strong>✓ Phone Verified:</strong>{" "}
                                            {this.state.country &&
                                            this.state.mobile
                                              ? `+${this.state.country}-${this.state.mobile}`
                                              : "Phone number verified"}
                                            <br />
                                            <button
                                              className="btn btn-sm btn-link mt-2 p-0"
                                              onClick={() => {
                                                // Clear phone verification data
                                                window.localStorage.removeItem(
                                                  "phoneVerification"
                                                );
                                                window.localStorage.removeItem(
                                                  "bookingFormData"
                                                );
                                                this.setState({
                                                  phoneVerified: false,
                                                  mobile: "",
                                                  country: "",
                                                  phoneVerificationUrl: null,
                                                });
                                              }}
                                            >
                                              Change Number
                                            </button>
                                          </div>
                                        )}

                                        <div className="p-1"></div>
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div
                                              id="respMsg"
                                              dangerouslySetInnerHTML={{
                                                __html: this.state.respMsg,
                                              }}
                                            ></div>
                                            {this.state.process === true ? (
                                              <div className="row">
                                                <div className="col-12 text-right">
                                                  <button
                                                    type="button"
                                                    className="btn btn-dark"
                                                    onClick={(e) => {
                                                      this.setState({
                                                        process: false,
                                                      });
                                                      document
                                                        .getElementById(
                                                          "verifyBook"
                                                        )
                                                        .classList.remove(
                                                          "d-block"
                                                        );
                                                    }}
                                                  >
                                                    CANCEL
                                                  </button>
                                                </div>
                                                <div className="col-12"></div>
                                              </div>
                                            ) : (
                                              <div className="row">
                                                <div className="col-6">
                                                  <button
                                                    type="button"
                                                    className="btn btn-dark"
                                                    onClick={(e) => {
                                                      document
                                                        .getElementById(
                                                          "verifyBook"
                                                        )
                                                        .classList.remove(
                                                          "d-block"
                                                        );
                                                    }}
                                                  >
                                                    CANCEL
                                                  </button>
                                                </div>
                                                <div className="col-12"></div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </>
                        ) : (
                          <>
                            <li
                              className="rb-item"
                              ng-repeat="itembx"
                              onClick={() => {
                                alert(
                                  this.props.global.user
                                    ? "Please fill all required fields to continue booking!"
                                    : "Please login to continue booking!"
                                );
                                window.location.href = "/#topbox";
                                document.getElementById("rb_login_e").click();
                              }}
                            >
                              {this.props.global.user ? (
                                <div className="rb-content">
                                  <div className="timestamp">
                                    Fill all required fields
                                  </div>
                                  <div className="item-title">
                                    To continue booking, please check you have
                                    selected valid{" "}
                                    <strong>date and a slot</strong>. Also,
                                    please add all required{" "}
                                    <strong>visitor data</strong>.
                                  </div>
                                </div>
                              ) : (
                                <div className="rb-content">
                                  <div className="timestamp">Login to Book</div>
                                  <div className="item-title">
                                    Login is required to make a booking. There
                                    is no cost for booking a ticket.
                                  </div>
                                </div>
                              )}
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      );
    }
  }
}

export default Booking;
